import { Link } from 'react-router-dom';

const references = [
  {
    location: 'Karşıyaka',
    type: 'Bioklimatik Pergola',
    year: '2025',
    desc: 'Villa bahçesine özel bioklimatik pergola. Dört mevsim kullanım konforu.',
    image: '/images/references/ref-home-1.webp',
    size: 'tall',
  },
  {
    location: 'Bornova',
    type: 'Kasetli Tente',
    year: '2025',
    desc: 'Kafe terasına motorlu kasetli tente. Müşteri kapasitesi %40 arttı.',
    image: '/images/references/ref-home-2.webp',
    size: 'normal',
  },
  {
    location: 'Buca',
    type: 'Zip Perde',
    year: '2024',
    desc: 'Restoran dış alanına zip perde sistemi. Kış aylarında da tam kapasite.',
    image: '/images/references/ref-home-3.webp',
    size: 'normal',
  },
  {
    location: 'Bayraklı',
    type: 'Otomatik Pergola',
    year: '2025',
    desc: 'Lüks konut projesine otomatik pergola. Akıllı ev sistemiyle entegre.',
    image: '/images/references/ref-home-4.webp',
    size: 'tall',
  },
  {
    location: 'Konak',
    type: 'Körüklü Tente',
    year: '2024',
    desc: 'İşyeri önüne geniş körüklü tente. Hem estetik hem fonksiyonel.',
    image: '/images/references/ref-home-5.webp',
    size: 'normal',
  },
  {
    location: 'Balçova',
    type: 'Rollingroof Pergola',
    year: '2025',
    desc: 'Otel havuz kenarına rollingroof pergola. Su geçirmez kumaş tavan.',
    image: '/images/references/ref-home-6.webp',
    size: 'normal',
  },
];

export default function ReferencesSection() {
  return (
    <section className="bg-[#f5f0e8] py-20 md:py-28" id="referanslar">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="font-body text-[#d4a853] text-xs font-semibold tracking-[0.25em] uppercase mb-4">— Tamamlanan İşler</p>
            <h2 className="font-heading text-4xl md:text-5xl text-[#0f1923] leading-tight">
              Projelerimiz ve <br />
              <span className="italic">Referanslarımız</span>
            </h2>
          </div>
          <Link
            to="/referanslar"
            className="inline-flex items-center gap-2 font-body text-sm font-semibold text-[#0f1923] border border-[#0f1923]/20 px-5 py-2.5 rounded-lg hover:bg-[#0f1923] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            Tüm Referanslar <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {references.map((ref, i) => (
            <div
              key={i}
              className={`group relative rounded-2xl overflow-hidden cursor-default ${ref.size === 'tall' ? 'sm:row-span-2' : ''}`}
            >
              <div className={`overflow-hidden ${ref.size === 'tall' ? 'h-72 sm:h-full sm:min-h-[420px]' : 'h-56'}`}>
                <img
                  src={ref.image}
                  alt={`${ref.type} ${ref.location} uygulaması`}
                  loading="lazy" decoding="async"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1923]/90 via-[#0f1923]/20 to-transparent"></div>

              {/* Top badges */}
              <div className="absolute top-4 left-4 flex gap-2">
                <span className="font-body bg-[#d4a853] text-[#0f1923] text-xs font-semibold px-3 py-1 rounded-full">{ref.location}</span>
                <span className="font-body bg-white/15 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full">{ref.year}</span>
              </div>

              {/* Bottom content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-heading text-lg text-white mb-1">{ref.type}</h3>
                <p className="font-body text-white/60 text-xs leading-relaxed">{ref.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
